module.exports = __webpack_public_path__ + "img/filter_img_none.0b728345.png";